import { useContext } from 'react';

import { translate } from '../../common/helpers/translate.helper';
import { IconX } from '../../common/icons/cdl/X';
import { Box } from '../../common/ui/Box';
import { IconButton } from '../IconButton/IconButton';
import { Text } from '../Text/Text';

import { DrawerContext } from './DrawerContext';
import type { StoredLayer } from './layerStoreReducer';
import { LayerStatus } from './types/LayerStatus';
import { useDrawer } from './useDrawer.hook';

interface DrawerHeaderProps {
    layer: StoredLayer;
    disabled: boolean;
}

export const DrawerHeader = ({ layer, disabled }: DrawerHeaderProps) => {
    const { requestClose, isTopLayer } = useDrawer();
    const { busyLayerIds } = useContext(DrawerContext);
    return (
        <Box
            display="flex"
            alignItems="flex-start"
            gap={16}
            padding={32}
            paddingBottom={24}
            borderBottom="default"
            borderColor="border.muted"
        >
            <Box display="flex" alignItems="center" flexWrap="wrap" gap={8} flex={1} minWidth={0}>
                <Text
                    id={`drawer-title-${layer.id}`}
                    as="h1"
                    variant="title"
                    color="foreground.default"
                    style={{ overflowWrap: 'anywhere' }}
                >
                    {layer.header.title}
                </Text>
                {layer.header.trailingVisual}
            </Box>
            <IconButton
                type="button"
                Icon={IconX}
                onClick={() => requestClose()}
                title={isTopLayer ? translate('drawer.closeTitle') : undefined}
                aria-label={translate('drawer.closeTitle')}
                disabled={disabled || busyLayerIds.has(layer.id) || layer.status === LayerStatus.CONFIRMING}
            />
        </Box>
    );
};
